(function ($) {
    $(function () {

        var loadingStars = function (){

            $(".vvns-customer-rating__ratings").each(function(){
                var score = parseFloat($(this).data('score'));

                var starsWidth = [0,0,0,0,0];

                for(var i = 0; i < starsWidth.length; i++) {
                    if(score > i) {
                        var starValue = i + 1;
                        starsWidth[i] = score >= starValue ? 100 : Math.round((score % 1) * 100);
                    }
                }

                $(this).find('.full-star-1').width(String(starsWidth[0]) + '%');
                $(this).find('.full-star-2').width(String(starsWidth[1]) + '%');
                $(this).find('.full-star-3').width(String(starsWidth[2]) + '%');
                $(this).find('.full-star-4').width(String(starsWidth[3]) + '%');
                $(this).find('.full-star-5').width(String(starsWidth[4]) + '%');
            });
        }

        var infoCard = function (){
            if (window.matchMedia('(max-width: 992px)').matches) {
                $(".vvns-customer-rating__stars-wrapper").click(function(){
                    $(".vvns-customer-rating-modal").toggle();
                });
            } else {
                $('.vvns-customer-rating__head-info, .vvns-customer-rating__modal-hover').hover(
                  function() {
                      $(this).find('.vvns-customer-rating-modal').css("opacity", "1");
                  },
                  function() {
                      $(this).find('.vvns-customer-rating-modal').css("opacity", "0");
                  }
                );
            }
        }

        infoCard();

        var textMore = function (){
            $('.vvns-customer-rating__customer-review').each(function(){
                if (window.matchMedia('(max-width: 992px)').matches){
                    if( $(this).text().length >= 192){
                        $(this).closest('.vvns-customer-rating__product-review').append("<p class='comment-more-less'>Göster</p>");
                        $('.vvns-customer-rating__customer-review').css({ "max-height": "52px", "overflow": "hidden" });
                    }
                }else{
                    if( $(this).text().length >= 295){
                        $(this).closest('.vvns-customer-rating__product-review').append("<p class='comment-more-less'>Göster</p>");
                        $('.vvns-customer-rating__customer-review').css({ "max-height": "60px", "overflow": "hidden" });
                    }
                }
            });


            $('.comment-more-less').click(function (){
                $(this).parent('.vvns-customer-rating__product-review').find('.vvns-customer-rating__customer-review').toggleClass("customer-comment-more-less");
                $(this).text(($(this).text() == 'Gizle') ? 'Göster' : 'Gizle');
            });
        }

        function isMobile(){
            var ratingDiv = $("#vvns-customer-rating-mobile");

            return parseInt(ratingDiv.length);
        }

        var commentList = $('.vvns-customer-rating__product-reviews');
        var productId = $(".vvns-customer-rating").data("product-id");
        var state = { limit:5, offset:0, orderBy:'score', sortOrder:'desc', score:0, size:0 };

        function renderComments(comments){
            var items = '';

            comments.forEach(function(comment) {
                items += "\
                <div class='vvns-customer-rating__product-review' data-date="+comment.createdOn+">\
                    <div class='vvns-customer-rating__rating-info'>\
                    \<div class='vvns-customer-rating__ratings' data-score="+comment.score+">\
                        \<span class='vvns-customer-rating__star-width'>\
                            \<span class='vvns-customer-rating__empty-star'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                            \<span class='vvns-customer-rating__full-star  full-star-1'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                        </span>\
                        \<span class='vvns-customer-rating__star-width'>\
                            \<span class='vvns-customer-rating__empty-star'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                            \<span class='vvns-customer-rating__full-star full-star-2'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                        </span>\
                        \<span class='vvns-customer-rating__star-width'>\
                            \<span class='vvns-customer-rating__empty-star'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                            \<span class='vvns-customer-rating__full-star full-star-3'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                        </span>\
                        \<span class='vvns-customer-rating__star-width'>\
                            \<span class='vvns-customer-rating__empty-star'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                            \<span class='vvns-customer-rating__full-star full-star-4'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                        </span>\
                        \<span class='vvns-customer-rating__star-width'>\
                            \<span class='vvns-customer-rating__empty-star'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                            \<span class='vvns-customer-rating__full-star full-star-5'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                        </span>\
                    </div>\
                        <p class='vvns-customer-rating__customer-review'>"+comment.comment+"</p>\
                    </div>\
                    \<div class='vvns-customer-rating__customer-info'>\
                       <span class='vvns-customer-rating__customer-name'>"+comment.customer.firstName+"</span>\
                       <span class='vvns-customer-rating__customer-name'>"+comment.customer.lastName+"</span>\
                       \<span class='vvns-customer-rating__separate'>|</span>\
                       <div class='vvns-customer-rating__customer-date'>\
                            <span>"+comment.createdOn+"</span>\
                        </div>\
                        \<span class='vvns-customer-rating__separate'>|</span>\
                        <div class='vvns-customer-rating__customer-country'>\
                            <span>"+comment.customer.city+"</span>\
                        </div>\
                        \<span class='vvns-customer-rating__separate'>|</span>\
                        <span class='vvns-customer-rating__customer-purchased'>Ürünü Satın Aldı</span>\
                    </div>\
                </div>"
            });

            commentList.append(items);
        }

        function renderCommentsMobile(comments){
            var items = '';

            comments.forEach(function(comment) {
                items += "\
                <div class='vvns-customer-rating__product-review' data-date="+comment.createdOn+">\
                    <div class='vvns-customer-rating__rating-info'>\
                        \<div class='vvns-customer-rating__rating-head'>\
                            \<div class='vvns-customer-rating__ratings' data-score="+comment.score+">\
                                \<span class='vvns-customer-rating__star-width'>\
                                    \<span class='vvns-customer-rating__empty-star'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                    \<span class='vvns-customer-rating__full-star full-star-1'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                </span>\
                                \<span class='vvns-customer-rating__star-width'>\
                                    \<span class='vvns-customer-rating__empty-star'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                    \<span class='vvns-customer-rating__full-star full-star-2'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                </span>\
                                \<span class='vvns-customer-rating__star-width'>\
                                    \<span class='vvns-customer-rating__empty-star'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                    \<span class='vvns-customer-rating__full-star full-star-3'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                </span>\
                                \<span class='vvns-customer-rating__star-width'>\
                                    \<span class='vvns-customer-rating__empty-star'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                    \<span class='vvns-customer-rating__full-star full-star-4'>\
                                        \<span class='vvns-customer-rating__star'></span>\
                                    </span>\
                                </span>\
                                \<span class='vvns-customer-rating__star-width'>\
                                \<span class='vvns-customer-rating__empty-star'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                            \<span class='vvns-customer-rating__full-star full-star-5'>\
                                \<span class='vvns-customer-rating__star'></span>\
                            </span>\
                        </span>\
                            </div>\
                            \<span class='vvns-customer-rating__customer-purchased'>Ürünü Satın Aldı</span>\
                        </div>\
                        \<p class='vvns-customer-rating__customer-review'>"+comment.comment+"</p>\
                        \<div class='vvns-customer-rating__customer-info'>\
                           <span class='vvns-customer-rating__customer-name'>"+comment.customer.firstName+"</span>\
                           <span class='vvns-customer-rating__customer-name'>"+comment.customer.lastName+"</span>\
                           \<span class='vvns-customer-rating__separate'>|</span>\
                           <div class='vvns-customer-rating__customer-date'>\
                                <span>"+comment.createdOn+"</span>\
                            </div>\
                            \<span class='vvns-customer-rating__separate'>|</span>\
                            <div class='vvns-customer-rating__customer-country'>\
                                <span>"+comment.customer.city+"</span>\
                            </div>\
                        </div>\
                    </div>\
                </div>"
            });

            commentList.append(items);
        }

        function getCommentsWithAjax(productId, limit, offset, orderBy, sortOrder, score) {
            if (state.isLoading) {
                return false;
            }

            state.isLoading = true;

            var url = '&limit=' + limit + '&offset=' + offset;

            if (orderBy) {
                url = url + "&orderBy=" + orderBy;
            }

            if (sortOrder) {
                url = url + "&sortOrder=" + sortOrder;
            }

            if (score) {
                url = url + "&score=" + score;
            }

            $.ajax('/musteri-yorumlari.html?productId=' + productId + '&ajax=1' + url, {
                method: 'GET',
            }).success(function (res) {
                var response = JSON.parse(res);

                if(isMobile()){
                    renderCommentsMobile(response.items);
                }else{
                    renderComments(response.items);
                }

                loadingStars();
                textMore();

                state.isLoading = false;
                state.size = response.size;

            });
        }

        loadingStars();
        //getCommentsWithAjax(productId, state.limit, state.offset, state.orderBy, state.sortOrder, state.score);



    });
})(jQuery);
